<div class="d-flex align-items-center picker-wrapper">
  <ng-container *ngIf="withArrows && formControl.value">
    <button
      type="submit"
      mat-button
      class="arrow-btn left t-footnote-semibold"
      [class.b-greyscale-500]="(_currentThemeSubject | async) === 'dark'"
      [class.b-greyscale-100]="(_currentThemeSubject | async) === 'light'"
      [class.dark-theme-bg-color]="(_currentThemeSubject | async) === 'dark'"
      [class.light-theme-bg-color]="(_currentThemeSubject | async) === 'light'"
      (click)="onSwitch('left'); $event.preventDefault()"
    >
      <mat-icon fontSet="material-symbols-outlined" class="arrow-icon">chevron_left</mat-icon>
    </button>
  </ng-container>

  <mat-form-field
    [appearance]="defaultAppearance"
    [floatLabel]="label ? 'auto' : 'always'"
    class="w-full date-picker-field"
  >
    <mat-label class="mat-field-label">{{ label }}</mat-label>
    <fb-anex
      *ngIf="prefix"
      matPrefix
      [config]="config?.prefix"
      [control]="control"
      [templates]="templates"
      position="start"
    ></fb-anex>

    <input
      matInput
      [owlDateTimeTrigger]="picker"
      [owlDateTime]="picker"
      [formControl]="formControl"
      fbDisableAutocomplete
      [placeholder]="placeholder"
      [required]="required"
      [minlength]="minLength"
      [maxlength]="maxLength"
      [readonly]="true"
      min="{{ min !== undefined ? min : min }}"
      [max]="maxDate || undefined"
      [fbDisableControl]="disable"
      (focusout)="onTouched()"
      [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
      [class.light-theme]="(_currentThemeSubject | async) === 'light'"
      class="date-input"
    />
    <button
      *ngIf="formControl.value && withReset"
      tabindex="-1"
      class="reset-button"
      type="button"
      mat-icon-button
      matSuffix
      (click)="onClear(); $event.stopPropagation(); $event.preventDefault()"
      [disabled]="disable || readonly"
    >
      <mat-icon [inline]="true">clear</mat-icon>
    </button>
    <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
      <ng-container>
        <fb-anex
          *ngIf="config?.suffix; else showToggle"
          matSuffix
          [config]="config?.suffix"
          [control]="control"
          [templates]="templates"
          position="end"
        ></fb-anex>
      </ng-container>
      <ng-template #showToggle>
        <mat-datepicker-toggle
          class="date-picker-toggle"
          tabindex="-1"
          [owlDateTimeTrigger]="picker"
        ></mat-datepicker-toggle>
      </ng-template>
    </ng-container>
    <ng-template #showLoader>
      <fb-loader class="position-relative loader" [size]="16" [message]="undefined" matSuffix></fb-loader>
    </ng-template>

    <owl-date-time
      [pickerType]="'calendar'"
      #picker
      [panelClass]="(_currentThemeSubject | async) === 'dark' ? 'darkPicker' : 'lightPicker'"
    ></owl-date-time>
  </mat-form-field>
  <ng-container *ngIf="withArrows && formControl.value">
    <button
      type="submit"
      mat-button
      class="arrow-btn right t-footnote-semibold"
      [class.b-greyscale-500]="(_currentThemeSubject | async) === 'dark'"
      [class.b-greyscale-100]="(_currentThemeSubject | async) === 'light'"
      [class.dark-theme-bg-color]="(_currentThemeSubject | async) === 'dark'"
      [class.light-theme-bg-color]="(_currentThemeSubject | async) === 'light'"
      (click)="onSwitch('right'); $event.preventDefault()"
    >
      <mat-icon fontSet="material-symbols-outlined" class="add-icon">chevron_right</mat-icon>
    </button>
  </ng-container>
</div>
